import { post, get } from '@/utils/request';

export function meituanWithdrawAataApi(data) {
  return get('/transfer/meituan/withdraw/data', data);
}

export function meituanWithdrawApi(data) {
  return post('/transfer/meituan/withdraw', data);
}

export function queryActivityPayListApi(data) {
  return post('/payinfo/ajax-queryActivityPayList', data);
}

export function querystatisticsListApi(data) {
  return post('/ajax-activity/statistics', data);
}

export function getRechargeDayApi(data) {
  return get('/transfer/getRechargeDay', data);
}



// WEBPACK FOOTER //
// ./src/api/pay.js